import "./style.css";

import React, { useEffect, useMemo, useState } from "react";

import { Button, Dropdown, Image, Input, Modal, Table, Tag } from "antd";
import { MoreOutlined, PlusOutlined, SearchOutlined } from "@ant-design/icons";
import moment from "moment/moment";

import { useDispatch, useSelector } from "react-redux";

import Loader from "../../components/loader/loader";
import PageHeader from "../../components/pageHeader/PageHeader";
import { userData as setReduxUser } from "../../redux/userDataSlice";
import {
  collection,
  doc,
  deleteDoc,
  getDocs,
  query,
  setDoc,
  updateDoc,
  where,
} from "firebase/firestore";
import { db, auth, firebaseConfig, functions } from "../../firebase";
import { initializeApp, deleteApp } from "firebase/app";
import {
  createUserWithEmailAndPassword,
  deleteUser,
  getAuth,
  signOut,
} from "firebase/auth";
import { httpsCallable } from "firebase/functions";
import {
  getFirebaseAuthErrorMessage,
  GreenNotify,
  RedNotify,
} from "../../helper/helper";
import CreateUserModal from "./CreateUserModal";
import EditRoleModal from "./updateUser/EditRoleModal";
import { uploadFile } from "../../helper/firebaseUpload";
import DiscussionDrawer from "../../components/DiscussionDrawer";

// The protected admin can never be removed (mirrors the server-side guard).
const PROTECTED_ADMIN_EMAIL = "admin@2ndhome.com";

const PromotorList = () => {
  const dispatch = useDispatch();
  const reduxUser = useSelector((state) => state.userDataSlice?.userData);
  const [isloading, setIsLoading] = useState(false);
  const [loading, setLoading] = useState(true);
  const [searchText, setSearchText] = useState("");
  const [usersData, setUsersData] = useState([]);
  const [signUpModal, setSignUpModal] = useState(false);
  const [update, setUpdate] = useState(false);
  const [editRoleModal, setEditRoleModal] = useState(false);
  const [selectedUser, setSelectedUser] = useState(null);
  // The user whose 1:1 DM thread is open (null = closed).
  const [messageUser, setMessageUser] = useState(null);

  const getUserStatus = (item) => {
    if (item?.isDeleted) {
      return { color: "error", label: "Deleted" };
    }
    if (item?.isBlocked) {
      return { color: "error", label: "Blocked" };
    }
    if (item?.isCompleted === "1") {
      return { color: "warning", label: "Incomplete" };
    }
    return { color: "success", label: "Active" };
  };

  const formatCreatedDate = (createdAt) => {
    const date = moment(createdAt);
    return date.isValid() ? date.format("MM-DD-YYYY") : "N/A";
  };

  // Last login is only recorded on an explicit credential/social sign-in (not
  // on silent session restore), so a missing value means "never since we
  // started tracking".
  const formatLastLogin = (lastLoginAt) => {
    const date = moment(lastLoginAt);
    return lastLoginAt && date.isValid()
      ? date.format("MM-DD-YYYY h:mm A")
      : "Never";
  };
  const columns = [
    {
      title: "Profile Picture",
      dataIndex: "profilePicture",
      align: "center",
    },
    {
      title: "Name",
      dataIndex: "name",
      className: "role-name-column-header",
      align: "center",
      sorter: (a, b) =>
        (a.name || "").toLowerCase().localeCompare((b.name || "").toLowerCase()),
    },
    // {
    //   title: "Contact Person",
    //   dataIndex: "name",
    //   className: "role-name-column-header",
    //   align: "center",
    // },
    {
      title: "Email",
      dataIndex: "email",
      className: "type-name-column-header",
      align: "center",
      sorter: (a, b) =>
        (a.email || "").toLowerCase().localeCompare((b.email || "").toLowerCase()),
    },
    {
      title: "Date",
      dataIndex: "dob",
      align: "center",
      className: "action-column-header",
      width: 200,
      sorter: (a, b) => (a.dobValue || 0) - (b.dobValue || 0),
    },
    {
      title: "Last Login",
      dataIndex: "lastLogin",
      align: "center",
      className: "action-column-header",
      width: 200,
      sorter: (a, b) =>
        (a.lastLoginValue || 0) - (b.lastLoginValue || 0),
    },
    {
      title: "Role",
      dataIndex: "role",
      align: "center",
      className: "action-column-header",
      width: 200,
      sorter: (a, b) => (a.role || "").localeCompare(b.role || ""),
    },
    {
      title: "Status",
      dataIndex: "status",
      align: "center",
      className: "action-column-header",
      sorter: (a, b) => (a.rawStatus || "").localeCompare(b.rawStatus || ""),
    },
    {
      title: "Actions",
      dataIndex: "actions",
      align: "center",
      className: "action-column-header",
    },
    // {
    //   title: "Block User",
    //   dataIndex: "blockORUnblock",
    //   align: "center",
    //   className: "action-column-header",
    //   render: (text, record) => (
    //     <div className="server-roles-trash-btn">
    //       {record.isBlocked ? (
    //         <Button
    //           className="server-roles-trash-btn"
    //           style={{
    //             width: "80px",
    //             color: "white",
    //             backgroundColor: "#52c41a",
    //           }}
    //           onClick={(event) => {
    //             console.log("unblock", record.email);
    //             return blocked(record.key, event, record.email, false);
    //           }}
    //         >
    //           Unblock
    //         </Button>
    //       ) : (
    //         <Button
    //           className="server-roles-trash-btn"
    //           style={{
    //             width: "80px",
    //             color: "white",
    //             backgroundColor: "#f5222d",
    //           }}
    //           onClick={(event) => {
    //             console.log("block", record.email);
    //             return blocked(record.key, event, record.email, true);
    //           }}
    //         >
    //           Block
    //         </Button>
    //       )}
    //     </div>
    //   ),
    // },
  ];

  const data = useMemo(() => {
    const normalizedSearch = searchText.trim().toLowerCase();

    return usersData
      ?.map((item) => {
        const status = getUserStatus(item);
        return {
          key: item?.id,
          _id: item?.id,
          name: item?.name === "" ? "N/A" : item?.name,
          role: item?.role === "admin" ? item.role : "employee",
          email: item?.email,
          dob: formatCreatedDate(item?.createdAt),
          dobValue: item?.createdAt ? moment(item.createdAt).valueOf() : 0,
          lastLogin: formatLastLogin(item?.lastLoginAt),
          lastLoginValue: item?.lastLoginAt
            ? moment(item.lastLoginAt).valueOf()
            : 0,
          profilePicture: (
            <div className="product-list-image">
              <Image
                style={{
                  borderRadius: "50%",
                  width: "46px",
                  height: "46px",
                  objectFit: "cover",
                }}
                src={item?.image}
                alt={
                  item?.name?.trim() !== ""
                    ? item.name?.split(" ")[0]
                    : "employee"
                }
              />
            </div>
          ),
          status: <Tag color={status.color}>{status.label}</Tag>,
          rawStatus: status.label,
          // All per-row actions in one kebab menu (keeps the table from spreading
          // across several action columns).
          actions: (
            <Dropdown
              trigger={["click"]}
              menu={{
                items: [
                  // Can't DM yourself; hide for the signed-in admin's own row.
                  ...(item?.id === auth.currentUser?.uid
                    ? []
                    : [
                        {
                          key: "message",
                          label: "Message",
                          onClick: () => setMessageUser(item),
                        },
                      ]),
                  {
                    key: "edit",
                    label: "Edit role",
                    onClick: () => handleOpenEditRole(item),
                  },
                  {
                    key: "block",
                    label: item?.isBlocked ? "Unblock" : "Block",
                    onClick: () => handleBlockUser(item),
                  },
                  {
                    key: "email",
                    label: "Send setup email",
                    onClick: () => handleSendResetEmail(item),
                  },
                  ...(item?.isDeleted
                    ? [
                        {
                          key: "restore",
                          label: "Restore",
                          onClick: () => handleRestoreUser(item),
                        },
                      ]
                    : []),
                  // Hide Remove for the protected admin (matches the server-side
                  // guard in the deleteUserAccount callable).
                  ...(item?.email === PROTECTED_ADMIN_EMAIL
                    ? []
                    : [
                        {
                          key: "remove",
                          label: "Remove",
                          danger: true,
                          onClick: () => handleRemoveUser(item),
                        },
                      ]),
                ],
              }}
            >
              <Button type="text" icon={<MoreOutlined />} />
            </Dropdown>
          ),
        };
      })
      .filter((item) => {
        if (!normalizedSearch) {
          return true;
        }
        const usernameMatch = item.name
          ?.toLowerCase()
          .includes(normalizedSearch);
        const emailMatch = item.email?.toLowerCase().includes(normalizedSearch);
        return usernameMatch || emailMatch;
      });
  }, [usersData, searchText]);

  const handleBlockUser = async (user) => {
    Modal.confirm({
      title: `Confirm ${user.isBlocked ? "Unblock" : "Block"}`,
      content: `Are you sure you want to ${
        user.isBlocked ? "unblock" : "block"
      } user ${user.name}?`,
      okText: user.isBlocked ? "Unblock" : "Block",
      okType: "danger",
      cancelText: "Cancel",
      onOk: async () => {
        try {
          setIsLoading(true);
          const userRef = doc(db, "users", user.id);
          await updateDoc(userRef, {
            isBlocked: !user.isBlocked,
            updatedAt: new Date().toISOString(),
          });
          GreenNotify(
            `User ${user.isBlocked ? "unblocked" : "blocked"} successfully`,
          );
          setUpdate((prev) => !prev);
        } catch (error) {
          RedNotify(error.message);
        } finally {
          setIsLoading(false);
        }
      },
    });
  };
  const handleRestoreUser = async (user) => {
    Modal.confirm({
      title: "Restore this account?",
      content: `This re-activates ${
        user.name && user.name !== "N/A" ? user.name : user.email
      }'s account so they can log in again.`,
      okText: "Restore",
      cancelText: "Cancel",
      onOk: async () => {
        try {
          setIsLoading(true);
          await updateDoc(doc(db, "users", user.id), {
            isDeleted: false,
            deletedAt: null,
            deletedBy: null,
            restoredAt: new Date().toISOString(),
            updatedAt: new Date().toISOString(),
          });
          GreenNotify("Account restored");
          setUpdate((prev) => !prev);
        } catch (error) {
          RedNotify(error.message);
        } finally {
          setIsLoading(false);
        }
      },
    });
  };
  const handleRemoveUser = async (user) => {
    const who = user.name && user.name !== "N/A" ? user.name : user.email;

    // Look up the blast radius before confirming: how many properties this
    // user covers as an inspector. Mirrors the server-side cleanup
    // (cleanupAuthOnUserDelete -> removeInspectorFromAssignments), which strips
    // them from every property's assignedInspectors + open inspections.
    let propCount = null; // null = lookup failed; show a generic warning instead
    try {
      const snap = await getDocs(
        query(
          collection(db, "properties"),
          where("assignedInspectors", "array-contains", user.id),
        ),
      );
      propCount = snap.size;
    } catch (error) {
      console.warn("property assignment lookup failed:", error?.message);
    }

    Modal.confirm({
      title: "Permanently remove this account?",
      width: 520,
      content: (
        <div>
          <p>
            This will delete <strong>{who}</strong>&rsquo;s login and profile.{" "}
            <strong>This cannot be undone.</strong>
          </p>
          {propCount === null ? null : propCount === 0 ? (
            <p>They are not currently assigned to any properties.</p>
          ) : (
            <p>
              They are currently assigned to{" "}
              <strong>
                {propCount} {propCount === 1 ? "property" : "properties"}
              </strong>
              .
            </p>
          )}
          <p style={{ marginBottom: 4 }}>What happens:</p>
          <ul style={{ marginTop: 0, paddingLeft: 20 }}>
            <li>Their login is deleted — they can no longer sign in.</li>
            <li>
              They&rsquo;re removed as an inspector from those properties and any
              open inspections.
            </li>
            <li>
              Any property where they were the only inspector becomes
              &ldquo;Unassigned&rdquo; in the scheduler.
            </li>
            <li>Completed inspections keep their name for the record.</li>
          </ul>
        </div>
      ),
      okText: "Remove",
      okType: "danger",
      cancelText: "Cancel",
      onOk: async () => {
        try {
          setIsLoading(true);
          // Delete the profile doc (admins are allowed to by Firestore rules).
          // A Firestore-trigger Cloud Function (cleanupAuthOnUserDelete) then
          // removes the matching Firebase Auth account, so no loginable orphan
          // is left behind.
          await deleteDoc(doc(db, "users", user.id));
          GreenNotify("Account removed successfully");
          setUpdate((prev) => !prev);
        } catch (error) {
          RedNotify(error.message);
        } finally {
          setIsLoading(false);
        }
      },
    });
  };

  const handleOpenEditRole = (user) => {
    setSelectedUser(user);
    setEditRoleModal(true);
  };

  const handleCloseEditRole = () => {
    setEditRoleModal(false);
    setSelectedUser(null);
  };

  const handleUpdateRole = async (values, imageFile, imageUrl) => {
    if (!selectedUser?.id) {
      return;
    }
    try {
      setIsLoading(true);
      const role = values.role === "admin" ? "admin" : "employee";

      const updates = {
        name: (values.name || "").trim(),
        role,
        updatedAt: new Date().toISOString(),
      };

      // Use the on-pick-uploaded photo if present; else upload the File now.
      if (imageUrl) {
        updates.image = imageUrl;
      } else if (imageFile) {
        const url = await uploadFile(imageFile, "users");
        if (!url) {
          throw new Error("Profile picture upload failed. Please try again.");
        }
        updates.image = url;
      }

      const userRef = doc(db, "users", selectedUser.id);
      await updateDoc(userRef, updates);
      // If the admin edited their own account, refresh redux so the header
      // avatar/name/role update immediately (no re-login needed).
      if (auth.currentUser?.uid === selectedUser.id) {
        dispatch(setReduxUser({ ...reduxUser, ...updates }));
      }
      GreenNotify("User updated successfully");
      handleCloseEditRole();
      setUpdate((prev) => !prev);
    } catch (error) {
      RedNotify(error.message);
    } finally {
      setIsLoading(false);
    }
  };

  const getRowClassName = (record, index) => {
    if (index % 2 === 0) {
      return "server-role-even-row";
    }
    return "server-role-odd-row";
  };
  const openSignUpModal = () => {
    setSignUpModal(true);
  };

  const handleCloseSignUpModal = () => {
    setSignUpModal(false);
  };

  // A strong throwaway password used only to create the account; the user never
  // sees it — they set their own via the password-setup email. The fixed prefix
  // guarantees the upper/lower/number/symbol policy regardless of the random tail.
  const generateTempPassword = () => {
    const bytes = new Uint32Array(8);
    window.crypto.getRandomValues(bytes);
    return "Aa1!" + Array.from(bytes, (b) => b.toString(36)).join("");
  };

  // Re-send the onboarding email (install the app + set-password link) to an
  // existing user — for when the original was lost, or to re-onboard someone.
  // Backed by the sendUserSetupEmail Cloud Function so it carries the App Store
  // install link (the bare Firebase reset email can't).
  const handleSendResetEmail = async (user) => {
    try {
      setIsLoading(true);
      const sendSetup = httpsCallable(functions, "sendUserSetupEmail");
      await sendSetup({ email: user.email });
      GreenNotify(`Invite email sent to ${user.email}`);
    } catch (error) {
      RedNotify(getFirebaseAuthErrorMessage(error?.code) || error.message);
    } finally {
      setIsLoading(false);
    }
  };

  const onFinish = async (values) => {
    setIsLoading(true);
    // Create the new auth user on a throwaway SECONDARY app. Calling
    // createUserWithEmailAndPassword on the primary `auth` would sign the
    // admin out and into the new account (and now persist that wrong session).
    const secondaryApp = initializeApp(firebaseConfig, `user-create-${Date.now()}`);
    const secondaryAuth = getAuth(secondaryApp);
    let createdUser = null;
    try {
      // We never ask the admin for a password. The account is created with a
      // throwaway random secret, then a password-setup email is sent so the user
      // chooses their own password and logs in. (They may also connect Google /
      // Apple in-app afterwards.)
      const tempPassword = generateTempPassword();
      const userCredential = await createUserWithEmailAndPassword(
        secondaryAuth,
        values.email,
        tempPassword,
      );
      createdUser = userCredential.user;

      // Save the profile doc via the PRIMARY db — the admin is still signed in
      // there, so the users/{uid} create passes the isAdmin() rule.
      const userRef = doc(db, "users", createdUser.uid);
      const newUserData = {
        uuid: createdUser.uid,
        email: createdUser.email,
        name: "N/A",
        role: values.role === "admin" ? "admin" : "employee", // Role assignment (FR-2)
        isBlocked: false,
        image:
          "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTL_JlCFnIGX5omgjEjgV9F3sBRq14eTERK9w&s",
        isCompleted: "1", // Default value
        createdAt: new Date().toISOString(), // Add a timestamp
      };
      await setDoc(userRef, newUserData);
      createdUser = null; // fully provisioned — nothing to roll back

      // Send the branded onboarding email (install the app + set-password link)
      // via the sendUserSetupEmail Cloud Function — it carries the App Store
      // install link the bare Firebase reset email can't. If it fails the account
      // still exists; the admin can resend from the row's "Send setup email".
      try {
        const sendSetup = httpsCallable(functions, "sendUserSetupEmail");
        await sendSetup({ email: values.email });
      } catch (mailError) {
        console.warn("Setup email failed to send:", mailError?.message);
      }

      setSignUpModal(false);
      GreenNotify(`User created — an invite email was sent to ${values.email}`);
      setUpdate((prev) => !prev);
    } catch (error) {
      // If the auth account was created but the profile write failed, delete
      // the orphan so the email can be reused (instead of "email-already-in-use").
      if (createdUser) {
        try {
          await deleteUser(createdUser);
        } catch (rollbackError) {
          console.warn("Orphaned user rollback failed:", rollbackError?.message);
        }
      }
      // Auth-create failures have "auth/" codes; a failed setDoc is a Firestore
      // error whose message is more useful than the generic auth fallback.
      const message = error?.code?.startsWith("auth/")
        ? getFirebaseAuthErrorMessage(error.code)
        : error?.message || "Failed to create user";
      RedNotify(message);
    } finally {
      // Tear down the secondary session/app so it never lingers.
      try {
        await signOut(secondaryAuth);
      } catch (e) {
        /* no-op */
      }
      await deleteApp(secondaryApp);
      setIsLoading(false);
    }
  };

  const fetchAllUsers = async () => {
    try {
      const snapshot = await getDocs(collection(db, "users"));
      const users = snapshot.docs.map((doc) => ({
        id: doc.id,
        ...doc.data(),
      }));
      setUsersData(users);
    } catch (error) {
      console.error("Error fetching users:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchAllUsers();
  }, [update]);
  return (
    <div className="admin-products-main-container">
      <Loader loading={loading} />
      <PageHeader
        eyebrow="Directory"
        title="Users"
        subtitle="Every account registered across 2nd Home."
        actions={
          <>
            <Input
              id="search"
              className="sh-search"
              allowClear
              prefix={<SearchOutlined />}
              placeholder="Search name or email"
              value={searchText}
              onChange={(e) => setSearchText(e.target.value)}
            />
            <Button
              type="primary"
              className="sh-add-btn"
              icon={<PlusOutlined />}
              onClick={openSignUpModal}
            >
              Add user
            </Button>
          </>
        }
      />
      <div className="server-roles-tb-main-container">
        <Table
          rowClassName={getRowClassName}
          rowKey="key"
          columns={columns}
          dataSource={data}
          pagination={true}
          className="subscriptionapi-table"
        />
      </div>
      <CreateUserModal
        visible={signUpModal}
        isLoading={isloading}
        onCancel={handleCloseSignUpModal}
        onSubmit={onFinish}
      />
      <EditRoleModal
        visible={editRoleModal}
        isLoading={isloading}
        user={selectedUser}
        onCancel={handleCloseEditRole}
        onSubmit={handleUpdateRole}
      />
      <DiscussionDrawer
        open={!!messageUser}
        onClose={() => setMessageUser(null)}
        kind="dm"
        otherUid={messageUser?.id}
        otherName={
          messageUser?.name && messageUser.name !== "N/A"
            ? messageUser.name
            : messageUser?.email
        }
        authorName={
          reduxUser?.name || auth.currentUser?.displayName || auth.currentUser?.email
        }
      />
    </div>
  );
};

export default PromotorList;
